import { fetchDataIfNecessary } from '../../../jsx/PlanSelectionNewWhatIfs/PlanSelectionNewWhatIfsActions';
import { isUuid } from './validators';

let callbackQueue = [];
let listenerAttached = false;

const planSelectionSelector = state => state.PlanSelectionNewWhatIfs;

export const localStorageKey = (clientId, storeId) =>
  `permanent-${window.ADV.util.env('isAdviserArea')}-${`${clientId}-${storeId}`}`;
export const allPlans = (state, clientId) => {
  const clientPlanSelection = planSelectionSelector(state)[clientId] || {};
  let all = clientPlanSelection.plans || [];

  if (clientPlanSelection.selectedPlan) {
    all = all.concat(clientPlanSelection.selectedPlan);
  }
  return all;
};
export const getAvailablePlans = (dispatch, state, clientId, onSuccess, onFailure) => {
  const plans = allPlans(state, clientId);
  if (!listenerAttached) {
    document.body.addEventListener('plans_loaded', e => {
      for (let i = 0, l = callbackQueue.length; i < l; i += 1) {
        callbackQueue[i].call(null, e.detail.plans);
      }
      callbackQueue = [];
    });
    listenerAttached = true;
  }
  if (
    !planSelectionSelector(state)[clientId] ||
    (planSelectionSelector(state)[clientId] && !planSelectionSelector(state)[clientId].loading)
  ) {
    if (plans.length <= 0) {
      callbackQueue.push(onSuccess);
      dispatch(fetchDataIfNecessary(clientId, () => {}, onFailure));
    } else {
      onSuccess.call(null, plans);
    }
  } else if (
    planSelectionSelector(state)[clientId] &&
    planSelectionSelector(state)[clientId].loading
  ) {
    callbackQueue.push(onSuccess);
  }
};
export const getDefaultFinancialPlanId = (clientId, onSuccess, onFailure) => {
  ADV.util
    .request(
      {
        uri: 'Consumer/ProposedPlans/GetDefaultFinancialPlanId',
        data: { clientId },
      },
      true,
    )
    .then(resp => {
      if (resp.success) {
        onSuccess(resp.payload.viewData);
      } else {
        onFailure((resp.errors || []).join('\n'));
      }
    })
    .catch(reason => onFailure(reason));
};

// This can have side effects, more exactly it will populate the financial plan list if it's empty.
export const getFinancialPlanId = (
  clientId,
  storeId,
  dispatch,
  state,
  onSuccess = () => {},
  onFailure = () => {},
) => {
  try {
    const fpId = localStorage.getItem(localStorageKey(clientId, storeId));
    if (isUuid(fpId)) {
      getAvailablePlans(
        dispatch,
        state,
        clientId,
        plans => {
          if (plans.find(({ planId }) => fpId === planId)) {
            onSuccess(fpId);
          } else {
            getDefaultFinancialPlanId(clientId, onSuccess, onFailure);
          }
        },
        reason => {
          console.warn(reason);
          getDefaultFinancialPlanId(clientId, onSuccess, onFailure);
        },
      );
    } else {
      getAvailablePlans(
        dispatch,
        state,
        clientId,
        () => {
          getDefaultFinancialPlanId(clientId, onSuccess, onFailure);
        },
        onFailure,
      );
    }
  } catch (_) {
    console.warn(_);
    getDefaultFinancialPlanId(clientId, onSuccess, onFailure);
  }
};
export const saveFinancialPlanId = (storeId, fpId, clientId) => {
  try {
    const key = localStorageKey(clientId, storeId);
    localStorage.setItem(key, fpId);
  } catch (_) {
    console.warn(_);
  }
};

window.ADV.util = Object.assign({}, window.ADV.util, {
  fetchDefaultFinancialPlanId: getFinancialPlanId,
});
